import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable, throwError} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../env';
import {UserWithDefaults} from '../../models/user';
import {catchError, map, publishReplay, refCount, shareReplay} from 'rxjs/operators';
import {Router} from "@angular/router";
import { AppLogger, AppLoggerService } from '../../core/logging';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  profile: Observable<UserWithDefaults>;
  private readonly log: AppLogger;

  constructor(private http: HttpClient, appLogger: AppLoggerService, private router: Router) {
    this.log = appLogger.createForClass(UserService);
  }

  getUserProfile(): Observable<UserWithDefaults> {
    if (!this.profile) {
      this.profile = this.http
        .get<UserWithDefaults>(`${environment.apiUrl}/users/me`)
        .pipe(
          // cache the result (similar to publishReplay(1), refCount())
          shareReplay({bufferSize: 1, refCount: true}),
          // handle errors
          catchError((err) => {
            if (err.status === 403) {
              // optional: clear the cache to force re-login if needed
              this.profile = null;
              // redirect to an error page or an unauthorized route
              this.router.navigateByUrl('/error/forbidden');
            }
            // rethrow so subscribers can still react if they want
            return throwError(() => err);
          })
        );
    }
    return this.profile;
  }

  clearCache() {
    this.profile = null;
  }

}
